var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mf-confirm-dialog',{attrs:{"title":_vm.title,"confirm-text":_vm.confirmText,"cancel-text":_vm.cancelText,"confirm-color":_vm.confirmColor,"cancel-color":_vm.cancelColor,"message":_vm.message},on:{"confirm":_vm.onConfirm,"cancel":_vm.onCancel},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})
}
var staticRenderFns = []

export { render, staticRenderFns }